import React from 'react';
import {useTranslation} from 'react-i18next';

import {useHotkey} from '@edna/hooks';

import Modal, {
  ModalActions,
  ModalCancelButton,
  ModalContent,
  ModalHeader,
  ModalSubmitButton,
} from './Modal';

export type TProps = {
  title?: React.ReactNode;
  loading?: boolean;
  width?: string;
  body: React.ReactNode;
  onOk: TEmptyFunction;
  closeModal: TEmptyFunction;
};

const Confirm = React.memo<TProps>(({title, body, width, onOk, loading, closeModal}) => {
  const {t} = useTranslation();
  const handleSubmit = React.useCallback(() => {
    onOk();
    closeModal();
  }, [onOk, closeModal]);

  useHotkey('Enter', handleSubmit);

  return (
    <Modal width={width}>
      <ModalHeader>{title || t(['EdnaModals:confirm.title', 'Modals:confirm.title'])}</ModalHeader>
      <ModalContent>{body}</ModalContent>
      <ModalActions>
        <ModalCancelButton onClick={closeModal}>
          {t(['EdnaModals:confirm.cancel', 'Modals:confirm.cancel'])}
        </ModalCancelButton>
        <ModalSubmitButton onClick={handleSubmit} loading={loading}>
          {t(['EdnaModals:confirm.ok', 'Modals:confirm.ok'])}
        </ModalSubmitButton>
      </ModalActions>
    </Modal>
  );
});

export default Confirm;
